import { Checkbox, Col, DatePicker, Form, Icon, Input, InputNumber, Row } from 'antd'
import DeliveryAddressModal from '../elements/DeliveryAddressModal'
import withKeyValue from '../elements/HOC/WithKeyValue'
import useFetchSelect from '../elements/Hooks/useFetchSelect'
import withSelectFetch from '../elements/Select/withSelectFetch'
import { get, isEmpty } from 'lodash'
import * as moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import { compose } from 'recompose'
import DangerousGoodsItem from '../components/Sales/Quotes/AddQuote/DangerousGoodsItem'
import ContactDetails from '../elements/ContactDetails'
import FormSectionTitle from '../elements/FormSectionTitle'
import withSort from '../elements/HOC/withSort'
import useDangerGoods from '../elements/Hooks/useDangerGoods'
import { useForceUpdate } from '../elements/Hooks/useForceUpdate'
import CustomSelect from '../elements/Select/CustomSelect'
import withData from '../elements/Select/withData'
import { defaultFormItemLayout, rules, threeFormItemLayout } from '../modules/FormItems'
import { arrVal, dateVal } from '../modules/Utils'
import withSpinning from './HOC/withSpinning'
import CountrySelect from '../elements/Select/Country'
import { GlobalContext } from 'Global'

const { TextArea } = Input

function DeliveryDetails(props) {
  const {
    getFieldDecorator,
    getFieldValue,
    setFieldsValue,
    resetFields,
    doc,
    listId,
    type,
    subType,
    showNotify,
    prefix,
    title,
    hideTitle,
    hideDangerous,
    hideExport,
    viewOnly,
  } = props

  const { tenantOptions, member } = React.useContext(GlobalContext)
  const attrPrefix = prefix ? `${prefix}.` : 'delivery.'

  const isEnquiry = type === 'Enquiry' && subType !== 'Sales Confirmation'
  const isSalesConfirmation = type === 'Enquiry' && ['Sales Confirmation', 'Phone Sales'].includes(subType)
  const isProductQuotation = type === 'Enquiry' && ['Product Quotation'].includes(subType)
  const isStockedProduct = type === 'Enquiry' && subType === 'Product Quotation'
  const isRFQ = type === 'RFQ'
  const isVQuote = type === 'vendorQuote'
  const isQuote = type === 'Quote'
  const isSales = type === 'Order'
  const isOrder = type === 'Purchase'
  const isService = type === 'Service'
  const isFreight = type === 'Freight'
  const isDeliveryOrder = type === 'DeliveryOrder'
  const isAccount = type === 'Account'
  const isPackage = type === 'Package'
  const isCargo = type === 'Cargo'

  const isDelivery = getFieldValue(attrPrefix + 'type') && !['N/A', 'TBC'].includes(getFieldValue(attrPrefix + 'type'))
  const isEXW = getFieldValue(attrPrefix + 'type') && getFieldValue(attrPrefix + 'type') === 'EXW'

  const isSeparateDelivery = getFieldValue(attrPrefix + 'quantity') === 'Multiple'

  const isDangerous = getFieldValue(attrPrefix + 'isDangerous')
  const [goods, setGoods] = useDangerGoods(
    arrVal(doc, attrPrefix + 'dangerousGoods').length,
    [doc._rev],
    !isEmpty(doc._rev)
  )

  const deliveryCountry = getFieldValue(attrPrefix + 'country') || get(doc, attrPrefix + 'country', '')

  const { SelectData: DeliveryAddress, fetch: fetchDeliveryAddress } = useFetchSelect({
    url: `${listId}/delivery`,
    dependencyArray: [listId],
    dontFetch: isEmpty(listId),
  })

  const packingInst = `EXPORT PACKING (ISPM 15 COMPLIANT)`
  const [preset, setPreset] = useState()
  const forceUpdate = useForceUpdate()
  useEffect(() => {
    if (!isEmpty(preset)) {
      doc.delivery = {
        ...preset.delivery,
        dangerousGoods: get(doc, attrPrefix + 'dangerousGoods'),
        isRestricted: get(doc, attrPrefix + 'isRestricted'),
        isDangerous: get(doc, attrPrefix + 'isDangerous'),
      }
    }
    forceUpdate()
  }, [preset])

  const compTitle = title
    ? title
    : `${isEnquiry || isSalesConfirmation || isQuote || isSales ? 'CUSTOMER' : 'VENDOR'} DELIVERY INSTRUCTION`

  const contract = (getFieldValue('contract._id') || get(doc, 'contract._id', '')).replace('salesContracts/', '')

  const { SelectData: DeliveryLocationSelect, data: locations } = useFetchSelect({
    url: `location/${deliveryCountry}`,
    dependencyArray: [deliveryCountry],
    dontFetch: isEmpty(deliveryCountry),
    mapFunction: (i) => ({
      ...i,
      display: `[${i.locode || i.code}] ${i.location}`,
    }),
  })

  // const address = getFieldValue(attrPrefix + 'address.label')
  // const { data: locode, fetching, fetch } = useFetch({
  //   url: 'locode?address=' + address,
  //   dependencyArray: [],
  //   dontFetch: isEmpty(address),
  // })
  //
  // useEffect(() => {
  //   if (locode) {
  //     const country = countries.find((i) => i.key === locode.Country) || {}
  //     console.log(country.value, locode.Country, locode.Location)
  //     setFieldsValue({
  //       [attrPrefix + 'country']: country.value,
  //       [attrPrefix + 'location']: locode.Country + locode.Location,
  //     })
  //   }
  // }, [locode])

  console.log(locations?.find((i) => i.locode === get(doc, attrPrefix + 'location')))

  return (
    <Fragment>
      {!hideTitle && <FormSectionTitle title={compTitle} />}

      {/*DELIVERY ADDRESSES FROM CONTRACT*/}
      {listId && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Preset Address">
              {getFieldDecorator(attrPrefix + 'default')(
                <DeliveryAddress
                  keyAtr={'key'}
                  style={{ width: '95%' }}
                  disabled={viewOnly}
                  valueAtr={'title'}
                  setSelected={setPreset}
                />
              )}
              <DeliveryAddressModal
                {...{
                  fetch: fetchDeliveryAddress,
                  key: contract,
                  contract,
                  type: 'Account',
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      )}

      {/*DELIVERY TYPE & IF APPLICABLE DELIVERY TERMS*/}
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Delivery Type">
            {getFieldDecorator(attrPrefix + 'type', {
              initialValue: get(doc, attrPrefix + 'type'),
              rules: rules.select,
            })(<DeliveryType disabled={viewOnly} />)}
          </Form.Item>
        </Col>
        {isDelivery && (
          <Col span={12} s>
            <Form.Item {...defaultFormItemLayout} label={'Delivery Terms'}>
              {getFieldDecorator(attrPrefix + 'terms', {
                initialValue: get(doc, attrPrefix + 'terms') || 'INCOTERMS 2010',
                rules: rules.select,
              })(<DeliveryTerms disabled={viewOnly} />)}
            </Form.Item>
          </Col>
        )}
      </Row>

      {isDelivery && ((!isRFQ && !isEnquiry && !isAccount && !isCargo && !isPackage) || isStockedProduct) && (
        // IF NOT RFQ & IS DELIVERY - NO OF DELIVERY DAYS OR DELIVERY DATE
        <Row>
          `
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="No of Deliveries">
              {getFieldDecorator(attrPrefix + 'quantity', {
                initialValue: get(doc, attrPrefix + 'quantity') || 'Single',
                rules: rules.select,
              })(<DeliveryQuantity disabled={viewOnly} />)}
            </Form.Item>
          </Col>
          {!isSeparateDelivery && !isOrder && !isSalesConfirmation && !isSales && !isDeliveryOrder && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Delivery Days'}>
                {getFieldDecorator(attrPrefix + 'no', {
                  initialValue: get(doc, attrPrefix + 'no') || 3,
                  rules: rules.input,
                })(
                  <InputNumber
                    disabled={viewOnly}
                    placeholder={'No of Days'}
                    onChange={(value) => {
                      if (value) {
                        const b = moment(getFieldValue('cpo.date') || getFieldValue('date'))
                        setFieldsValue({
                          [attrPrefix + 'date']: moment(b).add(value, 'days'),
                        })
                      } else {
                        setFieldsValue({
                          [attrPrefix + 'date']: undefined,
                        })
                      }
                    }}
                    style={{ width: '100%' }}
                  />
                )}
              </Form.Item>
            </Col>
          )}
          {!isSeparateDelivery && (isOrder || isSales || isDeliveryOrder || isSalesConfirmation) && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Delivery Date">
                {getFieldDecorator(attrPrefix + 'date', {
                  initialValue: dateVal(doc, attrPrefix + 'date'),
                  rules: rules.date,
                })(
                  <DatePicker
                    disabled={viewOnly}
                    onChange={(value) => {
                      if (value) {
                        const a = moment(value)
                        const b = moment(getFieldValue('cpo.date') || getFieldValue('date'))
                        console.log(a.diff(b, 'days'))
                        setFieldsValue({
                          [attrPrefix + 'no']: a.diff(b, 'days'),
                        })
                      }
                    }}
                    style={{ width: '100%' }}
                  />
                )}
              </Form.Item>
            </Col>
          )}
        </Row>
      )}

      {isDelivery && (isRFQ || isEnquiry) && isEXW ? (
        ' '
      ) : isDelivery ? (
        <>
          {/*<CustomSpin spinning={fetching}>*/}
          {/*  <Button type="primary" size="small" disabled={!address} onClick={fetch}>*/}
          {/*    Generate LoCode*/}
          {/*  </Button>*/}
          {/*</CustomSpin>*/}
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Delivery Address'}>
                {getFieldDecorator(attrPrefix + 'address.label', {
                  initialValue: get(doc, attrPrefix + 'address.label'),
                  //rules: !isQuote && !isRFQ && !isEnquiry && rules.input,
                  rules: rules.input,
                })(<TextArea placeholder={'Shipping Address'} disabled={viewOnly} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Delivery Description'}>
                {getFieldDecorator(attrPrefix + 'description', {
                  initialValue: get(doc, attrPrefix + 'description'),
                })(<TextArea placeholder={'Delivery Description'} disabled={viewOnly} />)}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Delivery Country'}>
                {getFieldDecorator(attrPrefix + 'country', {
                  initialValue: get(doc, attrPrefix + 'country'),
                  rules: rules.select,
                })(
                  <CountrySelect
                    valueAtr={'value'}
                    keyAtr={'value'}
                    disabled={viewOnly}
                    placeholder={`${getFieldValue(attrPrefix + 'type')} Location`}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={12} />

            {getFieldValue(attrPrefix + 'country') && (
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label="Location">
                  {getFieldDecorator(attrPrefix + 'location', {
                    initialValue: get(doc, attrPrefix + 'location'),
                    rules: !(isEnquiry || isQuote) && rules.select,
                  })(
                    <DeliveryLocationSelect disabled={viewOnly && !isAccount} keyAtr={'locode'} valueAtr={'display'} />
                  )}
                </Form.Item>
              </Col>
            )}

            {/*{getFieldValue(attrPrefix + 'country') && !isAccount && (*/}
            {/*  <Col span={12}>*/}
            {/*    <Form.Item {...defaultFormItemLayout} label="Location">*/}
            {/*      [{get(doc, attrPrefix + 'location')}]*/}
            {/*      {locations?.find((i) => i.locode === get(doc, attrPrefix + 'location'))?.location || ''}*/}
            {/*    </Form.Item>*/}
            {/*  </Col>*/}
            {/*)}*/}
          </Row>
        </>
      ) : (
        ' '
      )}

      {!isEXW && isDelivery && (
        // IF NOT EX WORKS - DELIVERY MODE
        <Row>
          {!isPackage && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Delivery Mode">
                {getFieldDecorator(attrPrefix + 'method', {
                  initialValue: get(doc, attrPrefix + 'method'),
                  rules: rules.select,
                })(<DeliveryMode disabled={viewOnly} />)}
              </Form.Item>
            </Col>
          )}
          {!isEnquiry && !isRFQ && !isQuote && !isPackage && !isCargo && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'Dropshippable'}>
                {getFieldDecorator(attrPrefix + 'dropshippable', {
                  initialValue: get(doc, attrPrefix + 'dropshippable'),
                  valuePropName: 'checked',
                })(<Checkbox disabled={viewOnly} />)}
              </Form.Item>
            </Col>
          )}
        </Row>
      )}

      {(((isOrder || isSales || isAccount || isDeliveryOrder) && isDelivery) || showNotify) && (
        <Fragment>
          <ContactDetails
            {...{
              getFieldDecorator,
              getFieldValue,
              setFieldsValue,
              title: 'Notify Party',
              doc,
              viewOnly,
              prefix: attrPrefix + 'notify',
            }}
          />
        </Fragment>
      )}
      <Row>
        {isDelivery && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Packing Instructions'}>
              {getFieldDecorator(attrPrefix + 'packingInst', {
                initialValue: get(doc, attrPrefix + 'packingInst') || packingInst,
                //rules: rules.input,
              })(<TextArea disabled={viewOnly} placeholder={'Packing Instructions'} />)}
            </Form.Item>
          </Col>
        )}
        {isDelivery && !isEXW && !isEnquiry && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Shipping Instructions'}>
              {getFieldDecorator(attrPrefix + 'shippingInst', {
                initialValue: get(doc, attrPrefix + 'shippingInst'),
                //rules: rules.input,
              })(<TextArea disabled={viewOnly} placeholder={'Shipping Instructions'} />)}
            </Form.Item>
          </Col>
        )}
      </Row>

      {isDelivery && !isRFQ && !isEnquiry && !isAccount && (
        <Row>
          {!hideExport && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'EXPORT RESTRICTED'}>
                {getFieldDecorator(attrPrefix + 'isRestricted', {
                  initialValue: get(doc, attrPrefix + 'isRestricted'),
                  valuePropName: 'checked',
                })(<Checkbox disabled={viewOnly} />)}
              </Form.Item>
            </Col>
          )}
          {!hideDangerous && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'DANGEROUS GOODS'}>
                {getFieldDecorator(attrPrefix + 'isDangerous', {
                  initialValue: get(doc, attrPrefix + 'isDangerous'),
                  valuePropName: 'checked',
                })(<Checkbox disabled={viewOnly} />)}
              </Form.Item>
            </Col>
          )}
        </Row>
      )}

      {isFreight && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Cargo Size">
              {getFieldDecorator(attrPrefix + 'size', {
                initialValue: get(doc, attrPrefix + 'size'),
              })(<DeliverySize disabled={viewOnly} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Loading Requirements">
              {getFieldDecorator(attrPrefix + 'loading', {
                initialValue: get(doc, attrPrefix + 'loading'),
              })(<DeliveryLoading disabled={viewOnly} />)}
            </Form.Item>
          </Col>
        </Row>
      )}

      {!hideDangerous && isDangerous && (
        <Row>
          <h3>
            DANGEROUS GOODS
            <Icon
              style={{
                cursor: 'pointer',
                fontSize: 18,
                marginLeft: 10,
              }}
              type="plus-circle"
              theme="filled"
              onClick={() => !viewOnly && setGoods((prvG) => prvG + 1)}
            />
            {goods > 1 && (
              <Icon
                style={{
                  cursor: 'pointer',
                  fontSize: 18,
                  marginLeft: 10,
                }}
                type="minus-circle"
                theme="filled"
                onClick={() => !viewOnly && setGoods((prvG) => prvG - 1)}
              />
            )}
          </h3>
          {Array.apply(null, { length: goods })
            .map(Number.call, Number)
            .map((item) => (
              <DangerousGoodsItem
                viewOnly={viewOnly}
                item={item}
                quote={doc}
                resetFields={resetFields}
                getFieldValue={getFieldValue}
                attrPrefix={attrPrefix}
                getFieldDecorator={getFieldDecorator}
              />
            ))}
        </Row>
      )}
      {isDelivery && !isEXW && (isProductQuotation || isSalesConfirmation || isSales || isDeliveryOrder) && (
        <Fragment>
          <Row>
            <FormSectionTitle title={'CONFIRMED TRACKING NUMBER'} />
            <Col
              span={12}
              style={{
                backgroundColor: '#55BDCA',
                color: 'white',
              }}>
              <Form.Item {...defaultFormItemLayout} label="Carrier">
                {getFieldDecorator(attrPrefix + 'carrier', {
                  initialValue: get(doc, attrPrefix + 'carrier'),
                })(<CarrierType style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
            <Col
              span={12}
              style={{
                backgroundColor: '#55BDCA',
                color: 'white',
              }}>
              <Form.Item {...threeFormItemLayout} label={'Tracking Number'}>
                {getFieldDecorator(attrPrefix + 'trackingNumber', {
                  initialValue: get(doc, attrPrefix + 'trackingNumber'),
                })(<Input placeholder={'trackingNumber'} style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
        </Fragment>
      )}
    </Fragment>
  )
}

const DeliveryQuantity = compose(
  withData({
    data: [
      {
        value: 'Single',
        key: 'Single',
      },
      {
        value: 'Multiple',
        key: 'Multiple',
      },
    ],
  }),
  withSort
)(CustomSelect)

const DeliveryType = compose(
  withData({
    data: [
      {
        key: 'N/A',
        value: 'NOT APPLICABLE',
      },
      {
        key: 'EXW',
        value: 'EX-WORKS',
      },
      {
        key: 'FOB',
        value: 'FREE ON-BOARD',
      },
      {
        key: 'FCA',
        value: 'FREE CARRIER (Named Place)',
      },
      {
        key: 'CFR',
        value: 'COST AND FREIGHT',
      },
      {
        key: 'CIF',
        value: 'COST INSURANCE FREIGHT',
      },
      {
        key: 'CPT',
        value: 'CARRIAGE PAID TO',
      },
      {
        key: 'CIP',
        value: 'CARRIAGE INSURANCE PAID TO',
      },
      {
        key: 'DAP',
        value: 'DELIVERED AT PLACE',
      },
      {
        key: 'DDP',
        value: 'DELIVERED DUTY PAID',
      },
      {
        key: 'TBC',
        value: 'TO BE CONFIRMED',
      },
    ],
  }),
  withSort
)(CustomSelect)

export const DeliveryMode = compose(
  withData({
    data: [
      {
        value: 'Air Freight',
        key: 'Air Freight',
      },
      {
        value: 'Sea Freight',
        key: 'Sea Freight',
      },
      {
        value: 'Land Freight',
        key: 'Land Freight',
      },
      {
        value: 'Intermodal',
        key: 'Intermodal',
      },
    ],
  }),
  withSort
)(CustomSelect)

const DeliverySize = compose(
  withData({
    data: [
      {
        value: 'LCL',
        key: 'LCL',
      },
      {
        value: 'FCL',
        key: 'FCL',
      },
    ],
  }),
  withSort
)(CustomSelect)

const DeliveryLoading = compose(
  withData({
    data: [
      {
        value: 'Bulk',
        key: 'Bulk',
      },
      {
        value: 'Container(s)',
        key: 'Container(s)',
      },
      {
        value: 'Pallet(s)',
        key: 'Pallet(s)',
      },
      {
        value: 'Box(es)',
        key: 'Box(es)',
      },
    ],
  }),
  withSort
)(CustomSelect)

const DeliveryTerms = compose(
  withData({
    data: [
      {
        key: 'INCOTERMS 2010',
        value: 'INCOTERMS 2010',
      },
    ],
  })
)(CustomSelect)

DeliveryDetails.defaultProps = {
  hideTitle: false,
  hideDangerous: false,
}

const CarrierType = compose(
  withSelectFetch({
    dropdown: 'tracking',
    name: 'carrier',
  }),
  withSpinning,
  withKeyValue(),
  withSort
)(CustomSelect)

export default DeliveryDetails
